module.exports = ".close { cursor: pointer }\n\n.growl-message-box {\n\tposition: fixed;\n\tright: 10px;\n    top: 70px;\n    z-index: 10000;\n\twidth: 400px;\n}\n\n.message-box {\n\tmargin-top: 30px;\n\tmargin-bottom: -20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/exa/alert/alert.component.css
// module id = ./src/app/exa/alert/alert.component.css
// module chunks = main